import type { Step as RcStep } from '@sb/remote-control/types';

import { type ValidationRule } from '../../types';
import type { WarningFinding } from '../../util/errors';
import { validateCodeExpression } from '../../util/validators';

import { CanonicalStepRuleBase } from './base';
import type { CanonicalValidateArgs } from './base';

class AnticipatePayloadRule extends CanonicalStepRuleBase {
  public constructor() {
    super('steps.AnticipatePayload', 'AnticipatePayload');
  }

  protected validate({ args, warn }: CanonicalValidateArgs): void {
    type APArgs = Extract<
      RcStep.Arguments,
      { argumentKind: 'AnticipatePayload' }
    >;
    const a = args as APArgs;
    this.checkMass(a);
    warn(this.checkMassExpression(a));
  }

  /**
   * Validate mass expression.
   * Throws ActionRequiredError if invalid.
   *
   * @throws {ActionRequiredError}
   */
  private checkMass(
    _args: Extract<RcStep.Arguments, { argumentKind: 'AnticipatePayload' }>,
  ): void {
    // mass is numeric in UI args; no expression validation needed
  }

  /**
   * Validate massExpression.
   * Throws ActionRequiredError if invalid.
   *
   * @throws {ActionRequiredError}
   */
  private checkMassExpression(
    args: Extract<RcStep.Arguments, { argumentKind: 'AnticipatePayload' }>,
  ): WarningFinding | undefined {
    return validateCodeExpression(
      args.massExpression,
      'massExpression',
      'Mass Expression',
    );
  }
}

export const AnticipatePayloadValidation: ValidationRule =
  new AnticipatePayloadRule().toValidationRule();
